export function resolveBackendBaseUrl(): string {
    const configuredBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL?.trim();

    if (configuredBaseUrl) {
        return configuredBaseUrl.replace(/\/+$/, '');
    }

    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'http://localhost:3001';
    }

    return '';
}